/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';

class Mail extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  render = () => (
    <SvgIcon width="28px" height="21px" viewBox="0 0 32 24" className={this.props.className}>
      <title>Mail Icon</title>
      <g id="Artboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M29,0 C29.833333,0 30.541667,0.291666985 31.125,0.875 C31.708333,1.45833302 32,2.16666698 32,3 L32,21 C32,21.833333 31.708333,22.541667 31.125,23.125 C30.541667,23.708333 29.833333,24 29,24 L3,24 C2.16666698,24 1.45833302,23.708333 0.875,23.125 C0.291666985,22.541667 0,21.833333 0,21 L0,3 C0,2.16666698 0.291666985,1.45833302 0.875,0.875 C1.45833302,0.291666985 2.16666698,0 3,0 L29,0 Z M29,3 L3,3 L3,5.5625 C4.45833302,6.72916698 7.27083302,8.9375 11.4375,12.1875 L12,12.6875 C12.833333,13.395833 13.5,13.895833 14,14.1875 C14.791667,14.729167 15.458333,15 16,15 C16.541667,15 17.208333,14.729167 18,14.1875 C18.5,13.895833 19.166667,13.395833 20,12.6875 L20.5625,12.1875 C24.729167,8.97916698 27.541667,6.77083302 29,5.5625 L29,3 Z M3,21 L29,21 L29,9.375 L21.75,15.125 C20.708333,16 19.854167,16.625 19.1875,17 C18.0625,17.666667 17,18 16,18 C15,18 13.916667,17.666667 12.75,17 C12.125,16.625 11.270833,16 10.1875,15.125 L3,9.375 L3,21 Z"
          id="envelope"
          fill="#434F5E"
        />
      </g>
    </SvgIcon>
  );
}

export default Mail;
